// extracted by mini-css-extract-plugin
module.exports = {"FromInvestors":"FromInvestors-module__FromInvestors___4I6WI","content":"FromInvestors-module__content___210dw","text":"FromInvestors-module__text___jS2nz"};